import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import About from '../../../../molecules/About';
import SiteMap from '../../../../molecules/SiteMap';
import Subscribe from '../../../../molecules/Subscribe';
import SocialMedia from '../../../../molecules/SocialMedia';

const CenterStackedVTwoBody = props => {
  const { bodyColor, pages, pagesClassName, subscribe, socialMedia, aboutUs } = props;

  const onSubmitLoading = () => new Promise(res => setTimeout(() => res(), 1000));

  const PagesColumn = () => (
    <React.Fragment key={`footer-page-${pages[0].title}`}>
      <Grid.Column
        className={pagesClassName}
        computer={3}
        tablet={3}
        only="computer tablet"
        textAlign="left"
      >
        <SiteMap links={pages[0].pages} />
      </Grid.Column>
      <Grid.Column className={pagesClassName} mobile={16} only="mobile" textAlign="center">
        <SiteMap links={pages[0].pages} />
      </Grid.Column>
    </React.Fragment>
  );

  const SubscribeColumn = () => (
    <React.Fragment>
      <Grid.Column computer={1} tablet={1} mobile={1} />
      <Grid.Column computer={6} tablet={6} mobile={14} textAlign="center">
        <h4 style={{ textTransform: 'none' }}>{subscribe.header}</h4>
        <Subscribe onSubmit={onSubmitLoading} placeholder={subscribe.placeholder} button={false} />
        <br />
        <SocialMedia socialMediaValues={socialMedia} buttonType="rect" />
      </Grid.Column>
      <Grid.Column computer={1} tablet={1} only="computer tablet" />
    </React.Fragment>
  );

  const AboutUsColumn = () =>
    aboutUs ? (
      <React.Fragment>
        <Grid.Column mobile={1} only="mobile" />
        <Grid.Column
          computer={3}
          tablet={3}
          mobile={12}
          textAlign="center"
          className="footer-aboutus-column"
        >
          <About header={aboutUs.header} withContainer content={aboutUs.content} headerAs="h4" />
        </Grid.Column>
        <Grid.Column mobile={1} only="mobile" />
      </React.Fragment>
    ) : null;

  return (
    <div style={{ backgroundColor: bodyColor, paddingTop: '2em', paddingBottom: '2em' }}>
      <Grid centered>
        <Grid.Column computer={1} tablet={1} only="computer tablet" />
        <PagesColumn />
        <SubscribeColumn />
        <AboutUsColumn />
        <Grid.Column computer={1} tablet={1} only="computer tablet" />
      </Grid>
    </div>
  );
};

CenterStackedVTwoBody.propTypes = {
  bodyColor: PropTypes.string.isRequired,
  pagesClassName: PropTypes.string,
};
CenterStackedVTwoBody.defaultProps = {
  pagesClassName: 'footer-pages',
};

export default CenterStackedVTwoBody;
